<div *ngIf="textGuide">
    <div class="title-panel">
        <div class="guide-logo">
            <img [src]="textGuide.logoLink" [alt]="textGuide.titleKey | translate">
        </div>
        <div class="guide-head-text">
            <h1>
                <span [innerHTML]="textGuide.titleKey | translate"></span><sup *ngIf="textGuide.titleIndexText">{{ textGuide.titleIndexText }}</sup>
            </h1>
            <div class="subtitle" [innerHTML]="textGuide.subtitleKey | translate"></div>
        </div>
    </div>
                
    <section class="guide-body flex-h">
        <div class="left-panel">
            <dynamic-text [opened]="true" [useCard]="false" [content]="getContent(textGuide.urls[0])"></dynamic-text>
        </div>
        <div class="right-panel" [ngStyle]="{'flex': '0 0 ' + (textGuide.rightPanelRatio ?? 45) + '%' }">
            <dynamic-text [opened]="true" [useCard]="false" [content]="getContent(textGuide.urls[1])"></dynamic-text>
        </div>
    </section>
</div>
